<template lang="pug">
  div.topbar-setting
    div.topbar-setting-button.fs-16(
      @click="handleOpen",
      v-Clickoutside="handleClose"
    ) 
      <el-autocomplete v-show="isAdmin" v-model="state4" :fetch-suggestions="querySearchAsync" placeholder="输入并选择水司" @select="handleSelect" :hide-loading="true" style="width:200px;margin-right:5px" ></el-autocomplete>
      span.topbar-setting-username.d-lg-inline {{realName}}{{customerId}}
      span.topbar-setting-img.thumbnail-wrapper.d32.circular.inline
        img(src="./setting-account.jpg",width="32",height="32")
    .dropdown-menu.dropdown-menu-right.profile-dropdown(:class="{'d-block':isActive}")
      //- router-link.dropdown-item(to="/setting/changePassword")
      //-   i.iconfont.icon-user
      //-   |  个人信息
      router-link.dropdown-item(to="/setting/changePassword")
        i.iconfont.icon-lock
        |  修改密码
      a.dropdown-item.clearfix.bg-master-lighter(@click="logout")
        span.float-left 退出
        span.float-right
          i.iconfont.icon-power-off
</template>

<script>
import Clickoutside from '../../../utils/clickoutside'
import { logout, expire } from '@/utils/auth'
import axios from 'axios'
axios.defaults.withCredentials = true

export default {
  name: 'Setting',
  directives: { Clickoutside },
  props: {
    realName: String,
    customerId: sessionStorage.customerId
  },
  data () {
    return {
      isActive: false,
      restaurants: [],
      isAdmin: false,
      state4: '',
      timeout: null,
      contains: '',
      pageNum: 1,
      a: null
    }
  },
  methods: {
    handleOpen () {
      this.isActive = !this.isActive
    },
    handleClose () {
      this.isActive = false
    },
    logout () {
      logout(() => {
        // this.$message({
        //   message: '退出成功',
        //   showClose: true,
        //   type: 'success'
        // })
        this.$swal('退出成功!', '', 'success')
        this.$router.push('/login')
      })
    },
    querySearchAsync (queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString ? this.createStateFilter(queryString, cb) : restaurants
      cb(results)
    },
    createStateFilter (queryString, cb) {
      let url = 'rbac/user/getOrgSelect?contains=' + queryString + '&pageNum=' + this.pageNum
      axios.get(url).then(res => {
        for (let i of res.data.list) {
          i.value = i[0]
          i.label = i[1]
        }
        this.restaurants = res.data.list
        cb(res.data.list)
        return res.data.list
      })
    },
    handleSelect (item) {
      let state1 = this.state4
      if (item === state1) {
        return
      } else {
        let url = 'rbac/user/setCustomer?id=' + item
        axios.get(url).then(res => {
          if (res.data === true) {
            this.state4 = item
            this.$message({
              type: 'success',
              message: '切换成功'
            })
          }
        }).catch(res => {
          this.$message({
            type: 'error',
            message: '为什么失败你心里没数吗？'
          })
        })
        this.state4 = item
      }
    },
    getSelect () {
      let url = 'rbac/user/getOrgSelect?contains=' + this.contains + '&pageNum=' + this.pageNum
      axios.get(url).then(res => {
        this.isAdmin = true
        for (let i of res.data.list) {
          i.value = i[0]
          i.label = i[1]
        }
        this.restaurants = res.data.list
      })
    },
    test111 () {
      let url = 'rbac/user/test'
      axios.get(url).then(res => {
        console.log(res)
      })
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    let customerId = sessionStorage.customerId
    if (customerId === '1') {
      this.getSelect()
    }
  }
}
</script>

<style lang="sass" scoped>
.topbar-setting
  float:left
  .profile-dropdown
    margin:auto
    float:left
    > a > i
      margin-right: 12px
    .dropdown-item
      &.active, &:active
        background: #eee
.topbar-setting-button
  float:left
  cursor: pointer
  text-align: center
  .topbar-setting-username
    display: none
    float:left
    line-height: 60px
  .topbar-setting-img
    margin: 14px
    float: right
</style>



// WEBPACK FOOTER //
// Setting.vue?54b8dd1c